import api from './api';

export const getNonNegotiables   = ()                => api.get('/non-negotiables').then(r => r.data);
export const createNonNegotiable = (data)            => api.post('/non-negotiables', data).then(r => r.data);
export const updateNonNegotiable = (id, data)        => api.put(`/non-negotiables/${id}`, data).then(r => r.data);
export const deleteNonNegotiable = (id)              => api.delete(`/non-negotiables/${id}`).then(r => r.data);
export const getTodayCompletions = (energy)          => api.get('/non-negotiables/today', {
  params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone, energy: energy || undefined },
}).then(r => r.data);
export const toggleCompletion    = (id, completed)   => api.post(`/non-negotiables/${id}/complete`, { completed }, {
  params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone },
}).then(r => r.data);
